<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('inventory.articles')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('inventory.articles')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import { isset } from 'src/util/Util';
import ArticleTable from 'src/views/Pages/Dashboard/Supplying/Inventory/Article/articles-table';
import EditCreate from 'src/views/Pages/Dashboard/Supplying/Inventory/Article/EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
    MixinRerender,
    MixinMenu,
  ],
  computed: {
    getModuleRoute() {
      return 'inventory/article';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ArticleTable().tableColumns],
        model: 'article',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
        handleCellStyle: ({ row, columnIndex }) => {
          if (Number(columnIndex) == 2) {
            if (isset(row.toxicity_classification_id)) {
              return `background-color: ${row.toxicity_classification_color};
              color: ${row.toxicity_classification_text_color};`;
            }
          }
        },
      };
    },
    dateToday() {
      return getDateToday();
    },
  },
};
</script>
